<template>
    <div class="large-claim-container" v-on-clickaway="leaveEditMode" @keyup.enter="leaveEditMode">
        <div :class="getStatusBackgroundColorClass(claim.status) + ' status'">
            <div class="status-container">
                <!-- <div class="backdrop"></div> -->
                <StatusIcon mode="light" class="status-icon" :status="claim.status"></StatusIcon>
            </div>
        </div>
        <div class="details">
            <div class="header">
                <div class="title" v-if="!editMode">{{ title | truncate}}</div>
                <input type="text" class="title" v-model="title" v-if="editMode"/>
            </div>
            <div class="body" v-html="markupBody" v-if="!editMode"></div>
            <div class="body" v-if="editMode">
                <textarea v-model="body"></textarea>
            </div>
        </div>
        <div class="action-bar">
            <div class="hidden" v-tooltip.right="'Edit Claim'">
                <fa-icon icon="edit" @click="enterEditMode()"></fa-icon>
            </div>
            <div class="hidden" v-tooltip.right="'Switch to Claim'">
                <fa-icon icon="sitemap" @click="openClaim()"></fa-icon>
            </div>
        </div>
        <!-- <div class="actions">
            <div class="action-button">
                <Clickable>
                    <fa-icon icon="exclamation" class="icon"></fa-icon>
                </Clickable>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway';
    import StatusIcon from './StatusIcon.vue';
    // import Clickable from './Clickable.vue';

    import { getStatusBackgroundColorClass, getStatusIconClass } from '../utility/StatusGenerator';
    import marked from 'marked';

    export default {
        mixins: [ clickaway ],
        props: {
            openInEditMode: Boolean,
            claim: Object,
        },
        components: {
            StatusIcon,
            // Clickable
        },
        methods: {
            getStatusBackgroundColorClass: getStatusBackgroundColorClass,
            enterEditMode: function() {
                this.editMode = true;
            },
            leaveEditMode: function() {
                if (this.editMode) {
                    this.editMode = false;
                    this.$emit('claimUpdated', {
                        ...this.claim,
                        id: this.id,
                        title: this.title,
                        body: this.body
                    });
                }
            },
            openClaim: function() {
                this.$emit('openClaim', this.id);
            }
        },
        data() {
            return {
                isTrue: this.status === 'true',
                isFalse: this.status === 'false',
                isDisputed: this.status === 'disputed',
                isAssumed: this.status ==='assumed',

                id: this.claim.id,
                title: this.claim.title,
                body: this.claim.body,

                editMode: this.claim.new,
            };
        },
        computed: {
            markupBody() {
                return this.body ? 
                    marked(this.body, { sanitize: true })
                    :
                    '';
            }
        },
        filters: {
            truncate: (value) => {
                if (value && value.length > 27) {
                    return value.substring(0, 27) + '...';
                }
                return value;
            }
        }
    }
</script>

<style scoped lang="scss">
    .large-claim-container {
        overflow: hidden;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;

        border-radius: $rounded-corners;
    
        box-shadow: $primary-shadow;

        margin-bottom: $space-64;

        min-height: $space-128;

        background-color: white;

        .status {
            width: $space-64 + 2;

            flex-grow: 0;
            flex-shrink: 0;

            .status-container {
                position: relative;
                top: 50%;
                margin-top: -$space-64 / 2;

                .status-icon {
                    width: $space-64;
                    height: $space-64;
                }
            }
        }

        .details {
            flex-grow: 1;
            
            > * {
                margin-left: $space-32;
                margin-right: $space-32;
            }

            .header {
                margin-top: $space-32;
                margin-bottom: $space-32;

                .title {
                    font-weight: $bold;
        
                    text-align: center;
                    margin-right: $space-16; //Alignment illusion
        
                    flex-grow: 1;
                    flex-shrink: 1;
                }
            }

            .body {
                margin-bottom: $space-32;

                text-align: left;

                textarea {
                    width: 100%;
                    height: 100%;
                    resize: none;
                }
            }
        }

        .action-bar {
            flex-grow: 0;
            flex-shrink: 0;

            padding: $space-8;
            width: $space-32 + $space-16;

            box-sizing: border-box;

            > div {
                width: $space-32;
                height: $space-32;
                line-height: $space-32;

                &:hover {
                    cursor: pointer;
                    background-color: $light-gray;
                }
            }
        }

        .hidden {
            display: none;
        }
        &:hover {
            .hidden {
                display: block;
            }
        }
        .actions {
            width: $space-64;

            flex-grow: 0;
            flex-shrink: 0;

            background-color: $gray;

            .action-button {
                position: relative;
                background-color: $light-gray;

                svg {
                    width: $space-32;
                    height: $space-32;

                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -$space-16;
                    margin-left: -$space-16;
                }

                height: 100%;
            }
        }
    }
</style>